import { Component, Input } from '@angular/core';
import { DateFormat } from '@app/core/types/date-format';

@Component({
  selector: 'itfg-ecr-data-section',
  templateUrl: './ecr-data-section.component.html',
  styleUrls: ['./ecr-data-section.component.scss'],
  standalone: false,
})
export class EcrDataSectionComponent {
  @Input() sectionData: any;
  @Input() columnsActive: any[];
  @Input() columnsRelatedEcr: any[];
  @Input() columnsActiveMultiproducts: any[];
  @Input() columnsOverdue: any[];
  @Input() columnsDelinquencyHistoryEcr: any[];
  @Input() columnsLegacyDelinquencyHistoryEcr: any[];
  @Input() columnsInquiryEcr: any[];
  dateFormat = DateFormat.DATE;
}
